import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/page-templates/cms-entry.template.js";
import { CallToAction } from "../components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`CMS Unreachable Page`}</h1>
    <h2>{`This page won't be reached by the CMS`}</h2>
    <p>{`It's just a regular MDX file, probably more like what you may be used to working with.
You can include components as you would normally.`}</p>
    <CallToAction url="/" align="center" mdxType="CallToAction">Head Back Home</CallToAction>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      